/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_SponsorInputs */

const en_landing_pricing_sponsor = /** @type {(inputs: Landing_Pricing_SponsorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sponsor`)
};

const zh_landing_pricing_sponsor = /** @type {(inputs: Landing_Pricing_SponsorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`赞助版`)
};

/**
* | output |
* | --- |
* | "Sponsor" |
*
* @param {Landing_Pricing_SponsorInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_sponsor = /** @type {((inputs?: Landing_Pricing_SponsorInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_SponsorInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_sponsor(inputs)
	return zh_landing_pricing_sponsor(inputs)
});
export { landing_pricing_sponsor as "landing.pricing.sponsor" }